define(['jquery', 'tabs', 'jquery.history'], function ($, tabs) {

    var experienceResults = new Array();
    var publicationResults = new Array();
    var newsResults = new Array();
    var eventsResults = new Array();
    var experiencePage = 1;
    var publicationPage = 1;
    var newsPage = 1;
    var eventPage = 1;
    var translationGuid;
    var itemguid = $(".tabs").attr("data-guid");
    var loadingPubs = false;
    var loadingNews = false;
    var loadingEvents = false;
    var manualStateChange = true;
    LoadContent();

    function escapeHtml(str) {
        if (str === undefined) {
            return undefined;
        }
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    };

    $('.nav__link.is-active').trigger('mouseover');
    (function (window, undefined) {
        // Define variables
        var History = window.History,
        State = History.getState();

        // Bind statechange event
        History.Adapter.bind(window, 'statechange', function () {
            var State = History.getState();
            if (manualStateChange == true) {
                LoadContent(State.data.tab);
                $('.nav__link.is-active').trigger('mouseover');
            }
            manualStateChange = true;
        });

    })(window)

    $(".tabs .nav__link").click(function (e) {
        e.preventDefault();
        var url = [location.protocol, '//', location.host, location.pathname].join('');
        var tab = escapeHtml($(this).text());
        var tabIndex = $(this).parent().attr("data-tabindex");
        var tabName = $(this).parent().attr("data-tabname");
        UpdateTitleTag(tab);
        LoadTab(tabIndex);
        manualStateChange = false;
        History.pushState({ tab: tabIndex, language: '' }, $("head title").text(), "?tab=" + encodeURIComponent(tabName));
    });

    $(".js-accordion-trigger.experience").click(function () {
        LoadExperience();
    });

    function LoadContent(index) {
        var queryString = window.location.search;
        queryString = queryString.substring(1);
        var params = queryString.split("&");
        var tab;
        for (i = 0; i < params.length; i++) {
            var temp = params[i].split("=");
            if (i == 0)
                tab = escapeHtml(temp[1]);
            else
                translationGuid = temp[1];
        }
        if (tab != undefined) {
            tab = decodeURIComponent(tab);
            var currentTab = $(".tabs").find('[data-tabname="' + tab + '"]');
            UpdateTitleTag($(currentTab).text());
            $(".nav__link").removeClass("is-active");
            $(".tabs__label").text($(currentTab).text())
            $(currentTab).find(".nav__link").addClass("is-active");
            if (index == undefined)
                index = currentTab.attr("data-tabindex");
        }
        LoadTab(index);
    }

    function LoadTab(index) {

        $(".loading-image").show();
        $(".tab-wrapper.col--main").hide();
        $(".intro.mod-intro").hide();
        $(".site-footer").hide();
        if (index == "1") {

            ajaxUrl = "/Layouts/WebUserControls/Main/Professionals/tabs/AjaxLoadBiography.aspx?lawyerGuid=" + itemguid;
            if (translationGuid != undefined)
                ajaxUrl = ajaxUrl + "&translationGuid=" + translationGuid;

            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(".tab-wrapper.col--main").html(p);
                BindTranslationClick();
                $(".tab-wrapper.col--main").fadeIn('slow');
                $(".site-footer").fadeIn('slow');
                $(".loading-image").hide();
            });
        }
        else if (index == "2") {
            ajaxUrl = "/Layouts/WebUserControls/Main/Professionals/tabs/AjaxLoadInsights.aspx?lawyerGuid=" + itemguid;
            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(".tab-wrapper.col--main").html(p);
                publicationPage = 1;
                eventPage = 1;
                LoadPublications();
                LoadUpcomingEvents();
                LoadRecentEvents();

                $(".js-accordion-trigger.publications").click(function () {
                    LoadPublications();
                });
                $(".js-accordion-trigger.recent-events").click(function () {
                    LoadRecentEvents();
                });

                $(".loading-image").hide();
            });
        }
        else if (index == "3") {
            ajaxUrl = "/Layouts/WebUserControls/Main/Professionals/tabs/AjaxLoadNews.aspx?lawyerGuid=" + itemguid;
            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(".tab-wrapper.col--main").html(p);
                newsPage = 1;
                LoadNews();

                $(".js-accordion-trigger.news").click(function () {
                    LoadNews();
                });
                $(".loading-image").hide();
            });
        }
        else if (index == "4") {
            ajaxUrl = "/Layouts/WebUserControls/Main/Professionals/tabs/AjaxLoadAdditionalTab.aspx?lawyerGuid=" + itemguid;
            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(".tab-wrapper.col--main").html(p);
                $(".tab-wrapper.col--main").fadeIn('slow');
                $(".site-footer").fadeIn('slow');
                $(".loading-image").hide();
            });
        }
        else {
            ajaxUrl = "/Layouts/WebUserControls/Main/Professionals/tabs/AjaxLoadOverview.aspx?Guid=" + itemguid;
            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(".tab-wrapper.col--main").html(p);
                experiencePage = 1;
                //get grouped if its there there are grouped experience and we are not going to show related
                var groupedCount = $(".mod-experience.grouped").find("li").length;
                if (groupedCount == 0)
                    LoadExperience();
                else {
                    $(".tab-wrapper.col--main").fadeIn('slow');
                    $(".site-footer").fadeIn('slow');
                    $(".intro.mod-intro").fadeIn('slow');
                    $(".loading-image").hide();
                    BindGroupViewMoreClick();
                }

                $(".js-accordion-trigger.experience").click(function () {
                    LoadExperience();
                })
                $(".loading-image").hide();
                $(".readmore-link.description").click(function () {
                    var url = [location.protocol, '//', location.host, location.pathname].join('');
                    var tab = $(this).text();
                    History.pushState(null, $(this).text(), url + "?tab=biography");
                    var tabIndex = 1;
                    UpdateTitleTag("biography");
                    LoadContent(1);
                    $('.nav__link.is-active').trigger('mouseover');
                });
            });
        }
    }

    function LoadExperience() {
        var experiencePageSize = parseInt($(".js-accordion-trigger.experience").attr("data-page-size"));

        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Experience/ExperienceSearchService.asmx/GetRelated",
            data: JSON.stringify({ guid: itemguid, startPage: experiencePage, pageSize: experiencePageSize + 1 }), //add 1 so we can tell if there are more to load
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                experienceResults = response.d;
                if (experienceResults.length == 0 && experiencePage == 1) {
                    $(".mod.mod-experience.related").hide();
                    $(".tab-wrapper.col--main").fadeIn('slow');
                    $(".site-footer").fadeIn('slow');
                    $(".intro.mod-intro").fadeIn('slow');
                    return;
                }
                if (experienceResults.length <= experiencePageSize)
                    $(".js-accordion-trigger.experience").hide();
                else
                    experienceResults.pop();       //get arid of last result it was just to check if there were more

                var ajaxUrl = "/Layouts/WebUserControls/Main/Experience/AjaxLoadTabListItems.aspx?guidArray=" + experienceResults.join(",");

                $.ajax({ url: ajaxUrl })
                 .done(function (p) {
                     $(".exp-listing.related").append(p);
                     $(".tab-wrapper.col--main").fadeIn('slow');
                     $(".site-footer").fadeIn('slow');
                     $(".intro.mod-intro").fadeIn('slow');
                     experiencePage = experiencePage + 1;
                 });
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadPublications() {
        var publicationPageSize = parseInt($(".js-accordion-trigger.publications").attr("data-page-size"));

        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetRelatedPublications",
            data: JSON.stringify({ entityGuid: itemguid, startPage: publicationPage, pageSize: publicationPageSize + 1 }), //add 1 so we can tell if there are more to load
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                publicationResults = response.d;
                if (publicationResults.length == 0 && publicationPage == 1) {
                    $(".mod.mod-insights.publications").hide();
                    return;
                }
                if (publicationResults.length <= publicationPageSize)
                    $(".js-accordion-trigger.publications").hide();
                else {
                    publicationResults.pop();       //get arid of last result it was just to check if there were more
                    $(".js-accordion-trigger.publications").show();
                }

                RecursiveLoadListItems(0, publicationResults, $(".mod.mod-insights.publications .articles-list"))

                publicationPage = publicationPage + 1;

            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadNews() {
        var newsPageSize = parseInt($(".js-accordion-trigger.news").attr("data-page-size"));

        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetRelatedNews",
            data: JSON.stringify({ entityGuid: itemguid, startPage: newsPage, pageSize: newsPageSize + 1 }), //add 1 so we can tell if there are more to load
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                newsResults = response.d;
                if (newsResults.length == 0 && newsPage == 1) {
                    $(".mod.mod-news").hide();
                    return;
                }
                if (newsResults.length <= newsPageSize)
                    $(".js-accordion-trigger.news").hide();
                else {
                    newsResults.pop();       //get arid of last result it was just to check if there were more
                    $(".js-accordion-trigger.news").show();
                }

                RecursiveLoadListItems(0, newsResults, $(".mod.mod-news .articles-list"));

                newsPage = newsPage + 1;

            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadUpcomingEvents() {
        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetRelatedUpcomingEventsNew",
            data: JSON.stringify({ entityGuid: itemguid }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                eventsResults = response.d;
                if (eventsResults.length == 0 && eventPage == 1) {
                    $(".mod.mod-events .upcoming").hide();
                    return;
                }
                RecursiveLoadListItems(0, eventsResults, $(".mod.mod-events .upcoming .articles-list"), true)
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadRecentEvents() {
        var eventsPageSize = parseInt($(".js-accordion-trigger.recent-events").attr("data-page-size"));

        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetRelatedRecentEvents",
            data: JSON.stringify({ entityGuid: itemguid, startPage: eventPage, pageSize: eventsPageSize + 1 }), //add 1 so we can tell if there are more to load
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                eventsResults = response.d;
                if (eventsResults.length == 0 && eventPage == 1) {
                    $(".mod.mod-events .recent").hide();
                    return;
                }
                if (eventsResults.length <= eventsPageSize)
                    $(".js-accordion-trigger.recent-events").hide();
                else {
                    eventsResults.pop();       //get arid of last result it was just to check if there were more
                    $(".js-accordion-trigger.recent-events").show();
                }

                RecursiveLoadListItems(0, eventsResults, $(".mod.mod-events .recent .articles-list"), true)

                eventPage = eventPage + 1;
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }
    function RecursiveLoadListItems(index, items, targetElement, showAdditionalFields) {
        if (index >= items.length) {
            $(".tab-wrapper.col--main").fadeIn('slow');
            $(".site-footer").fadeIn('slow');
            return;
        }
        var ajaxUrl = "/Layouts/WebUserControls/Main/Insights/AjaxLoadListItem.aspx?guid=" + items[index];
        if (showAdditionalFields)
            ajaxUrl += '&showadditionalfields=true';

        $.ajax({ url: ajaxUrl })
            .done(function (p) {
                $(targetElement).append(p);
                RecursiveLoadListItems(index + 1, items, targetElement, showAdditionalFields);
            });
    }

    function UpdateTitleTag(tab) {
        if (tab && tab !== 'undefined' && typeof tab !== 'undefined') {
            var titleTag;
            var titleTagParts = $("head title").text().split("|");
            var namePart = titleTagParts[0];
            if (titleTagParts[0].indexOf("-") != -1)
                namePart = titleTagParts[0].substring(0, titleTagParts[0].indexOf("-"));
            namePart = namePart + " - " + tab;
            titleTag = namePart;
            for (i = 1; i < titleTagParts.length; i++) {
                titleTag = titleTag + " | " + titleTagParts[i];
            }
            $("title").text(titleTag.replace(" and ", " & ").replace("&amp;", "&"));
        }
    }

    function BindLoadMoreClick() {
        $(".js-accordion-trigger.publication").click(function () {
            LoadExperience();
        });
    }

    function BindGroupViewMoreClick() {
        $(".js-accordion-trigger.experience-group").click(function () {
            var guid = $(this).attr("data-guid");
            var skip = $(this).attr("data-skip");
            ajaxUrl = "/Layouts/WebUserControls/Main/Experience/AjaxLoadGroupListItems.aspx?groupGuid=" + guid + "&skip=" + skip;
            var list = $(this).parent().find(".exp-listing__items");
            $(this).hide();
            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(list).append(p);

            });
        });
    }

    function BindTranslationClick() {
        $(".translation").click(function () {
            $("filtering__action").removeClass("is-active");
            $(this).addClass("is-active");
            translationGuid = $(this).attr("data-translation-guid");
            LoadTab(1, translationGuid);
            if (translationGuid != undefined)
                History.pushState({ tab: 1, language: translationGuid }, $("head title").text(), "?tab=" + encodeURIComponent("Biography") + "&language=" + translationGuid);
            else
                History.pushState({ tab: 1, language: translationGuid }, $("head title").text(), "?tab=" + encodeURIComponent("Biography"));
        });
    }
});